// extracted by mini-css-extract-plugin
export default {"descriptionText":"_1m17ftk"};